import { linkify } from "./linkify/linkify";
const containsUrl = (url) => url && url[0] !== "#" && linkify.test(url);
export {
  containsUrl
};
//# sourceMappingURL=contains-url.js.map
